<template>
  <div class="app-switch">
    <v-switch
      :input-value="value"
      :label="label"
      :error="hasError"
      :readonly="readonly"
      :disabled="disabled"
      :hide-details="hideDetails"
      :true-value="trueValue"
      :false-value="falseValue"
      :error-messages="$formErrors(v)"
      @change="change"
      color="secondary"
    />
  </div>
</template>

<script>
export default {
  name: 'AppSwitch',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    v: {
      type: [Boolean, Object],
      default: false
    },
    forceError: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    trueValue: {
      default: undefined
    },
    // eslint-disable-next-line vue/require-prop-types
    falseValue: {
      default: undefined
    }
  },
  computed: {
    hasError () {
      return this.v
        ? (this.v.$invalid && this.v.$dirty) || this.forceError
        : false
    }
  },
  methods: {
    change (value) {
      if (this.v && 'boolean' !== typeof this.v) this.v?.$touch()
      if (value) {
        this.$emit('input', this.trueValue || !!value)
        this.$emit('change', this.trueValue || !!value)
        return
      }

      this.$emit('input', this.falseValue || !!value)
      this.$emit('change', this.falseValue || !!value)
    }
  }
}
</script>
